import script from "./UploadDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadDialog.vue?vue&type=script&lang=ts&setup=true"

import "./UploadDialog.vue?vue&type=style&index=0&id=31f03d91&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31f03d91"]])

export default __exports__